import React, { memo } from 'react';
import classnames from 'classnames';
import { bool, func } from 'prop-types';
import FormGroup from '@active/react-ui/FormGroup';
import FormField from '@active/react-ui/FormField';
import FormLabel from '@active/react-ui/FormLabel';
import Input from '@active/react-ui/Input';
import Locale from '@active/react-utils/i18n/Locale';
import { cvvValidator } from '../../utils/validators';
import './CVVField.scss';

const CVVField = ({
  i18n, isCVVEnable, withoutLayout, displayCVVHelpTextAfterLabel, hideCVVHelpText, ...rest
}) => {
  if (!isCVVEnable) {
    return null;
  }

  const cvvValidate = value => cvvValidator(i18n, value);

  const Label = () => <FormLabel>
    <Locale id="checkout.lib.components.creditCard.label.cvv" />
  </FormLabel>;
  const Field = () => <FormField
    {...rest}
    as={Input}
    hint={hideCVVHelpText ? undefined : i18n('checkout.lib.components.creditCard.tip.cvv')}
    autoComplete="cc-csc"
    validate={cvvValidate}
    maxlength="10"/>;

  const preItemClasses = classnames(
    'pre-text__item',
    {
      'grid grid-no-row-gap': !withoutLayout,
    },
  );

  const preItemLabelClasses = classnames(
    {
      'grid-item span-sm-12 span-md-3 offset-md-1': !withoutLayout,
    },
  );

  const preItemFieldClasses = classnames(
    'pre-text__item-field',
    {
      'grid-item span-sm-12 span-md-4': !withoutLayout,
    },
  );

  return (
    <div className="checkout__cc__cvv">
      <FormGroup name="cvv" withoutLayout={displayCVVHelpTextAfterLabel || withoutLayout} required>
        {displayCVVHelpTextAfterLabel
          ? <div className={preItemClasses}>
            <div className={preItemLabelClasses}><Label /></div>
            <div className={preItemFieldClasses}>
              { !hideCVVHelpText && <div className="cvv-pre__help-text"><Locale id="checkout.lib.components.creditCard.tip.cvv" /></div> }
              <Field />
            </div>
          </div>
          : <>
            <Label />
            <Field />
          </>}
      </FormGroup>
    </div>
  );
};

CVVField.propTypes = {
  i18n: func.isRequired,
  isCVVEnable: bool.isRequired,
  displayCVVHelpTextAfterLabel: bool,
  hideCVVHelpText: bool,
};

CVVField.defaultProps = {
  displayCVVHelpTextAfterLabel: false,
  hideCVVHelpText: false,
};

export default memo(CVVField);
